export function HasNode(type, value) {
  return value.blocks.some(block => {
    const ancestors = [];
    value.document.getAncestors(block.key).forEach(anc => {
      ancestors.push(anc.type);
    });
    if (ancestors.includes(type)) {
      return true;
    }
    return block.type === type;
  });
}
